import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { UserSessionService } from '@services/user-session.service';
import { AppLoggerService } from '@services/app-logger.service';
import { formRoute } from '@services/component-pages.service';

// HU-205152 Descarga de Certificados — Clientes Antiguos sin Productos Vigentes.
export const CERTIFICATES_ONLY_SESSION_FLAG = 'certificatesOnlyAccess';
const CERTIFICATES_FORM_CODE = 'certificates';
const RESTRICTED_ACCESS_MESSAGE =
  'Esta función es exclusiva para clientes con productos activos. Puedes descargar tus certificados desde aquí.';

/**
 * Un cliente marcado `certificatesOnlyAccess` (todos sus productos cerrados) solo puede
 * navegar al módulo de certificados. `canActivateChild` (no `canActivate`) porque authGuard
 * ya está puesto a nivel de módulo padre y, con `runGuardsAndResolvers: 'emptyOnly'` (default
 * de Angular), navegar entre rutas hijas hermanas ya activadas no vuelve a ejecutar el guard
 * del padre — canActivateChild sí se reevalúa en cada activación de hijo.
 */
export const certificatesOnlyGuard: CanActivateChildFn = (_childRoute, state) => {
  const userSession = inject(UserSessionService);
  const router = inject(Router);
  const logger = inject(AppLoggerService);
  const notification = inject(NzNotificationService);

  const sessionData = userSession.getSessionData();
  const isCertificatesOnly = !!sessionData?.[CERTIFICATES_ONLY_SESSION_FLAG];
  if (!isCertificatesOnly) {
    return true;
  }

  const urlSegments = state.url.split('?')[0].split('/').filter(Boolean);
  if (urlSegments.includes(CERTIFICATES_FORM_CODE)) {
    return true;
  }

  logger.debug('[CERTIFICATES-ONLY GUARD] Acceso restringido, redirigiendo a certificados');
  notification.info('Acceso restringido', RESTRICTED_ACCESS_MESSAGE, { nzDuration: 6000, nzPlacement: 'topRight' });

  return router.parseUrl(`/${formRoute(CERTIFICATES_FORM_CODE)}`);
};
